module.exports = "/images/sub-promo.png?e7d817aa2b00964882a0a27061e4a398";